import React, {useEffect, useState} from 'react';
import * as _ from 'lodash';
import ErrorPage from './ErrorPage';
import {base64ToJson, getCookie, getJsonQueryString, removeCookie, getErrorRequestIdAsString} from '../../common/utils';
import {CIG_SSO} from '../../common/constants';
import {
    AuthenticationFailureErrorMessage,
    Auth0ServerValidationFailureErrorMessage,
    LoginRedirectionErrorMessage
} from './ErrorMessagesComps';
import {getMessage} from '../../common/messageCatalog';


export function ErrorWrapperPage({auth, props}) {
    const [err, setErr] = useState({});
    const [unknownError, setUnknownError] = useState(false);

    useEffect(() => {
        const queryStr = getJsonQueryString()
        let ckName = _.get(queryStr, CIG_SSO.cookiesKey, '');
        let ckValue = getCookie('', ckName);

        if (!_.isEmpty(ckValue)) {
            const errJson = base64ToJson(ckValue, false);
            errJson.cookie = ckName;
            removeCookie(ckName);
            setErr(errJson);
        }
        else {
            setUnknownError(true);
        }
    }, [props]);

    const renderError = () => {
        if (!_.isEmpty(err)) {
            const requestIdStr = getErrorRequestIdAsString(err);
            const errorProps = getMessage(err.uiMessageCode, requestIdStr, err);
            if (err.errorCode === 1026 || err.errorCode === 1027) {
                return <ErrorPage id="redirect-error"
                    title={errorProps.title}
                    serverMsg={err.errorMessage + ', ' + err.rootCauseMessage}
                    errorCode={err.errorCode}
                    httpStatusCode={err.httpStatus}
                    auth={auth}
                    site={err.ciSite}
                    tenantId={err.tenantId}
                    requestId={requestIdStr}
                    logPrefix='ErrorWrapperPage:'>

                    <LoginRedirectionErrorMessage message={errorProps.message} ciSite={err.ciSite}/>
                </ErrorPage>
            }
            else if (err.errorCode === 1705 ){
                return <ErrorPage id="redirect-error"
                    title={errorProps.title}
                    serverMsg={err.errorMessage + ', ' + err.rootCauseMessage}
                    errorCode={err.errorCode}
                    httpStatusCode={err.httpStatus}
                    auth={auth}
                    requestId={requestIdStr}
                    logPrefix='ErrorWrapperPage:'>

                    <AuthenticationFailureErrorMessage message={errorProps.message} />
                </ErrorPage>
            }
            else if (err.errorCode === 1706 ){
                return <ErrorPage id="redirect-error"
                    title={errorProps.title}
                    serverMsg={err.errorMessage + ', ' + err.rootCauseMessage}
                    errorCode={err.errorCode}
                    httpStatusCode={err.httpStatus}
                    auth={auth}
                    requestId={requestIdStr}
                    logPrefix='ErrorWrapperPage:'>

                    <Auth0ServerValidationFailureErrorMessage message={errorProps.message} />
                </ErrorPage>
            }
            else {
                return <ErrorPage id="redirect-error"
                    title={errorProps.title}
                    message={!_.isNil(errorProps.message) ? errorProps.message : ''}
                    serverMsg={err.errorMessage + ', ' + err.rootCauseMessage}
                    errorCode={err.errorCode}
                    httpStatusCode={err.httpStatus}
                    auth={auth}
                    site={err.ciSite}
                    tenantId={err.tenantId}
                    requestId={requestIdStr}
                    logPrefix='ErrorWrapperPage:'>

                </ErrorPage>
            }
        }
        if (unknownError) {
            const queryStr = getJsonQueryString()
            let ckName = _.get(queryStr, CIG_SSO.cookiesKey, '');
            let ckValue = getCookie('', ckName);
            return (
                <ErrorPage id="unknown-error" title='We are unable to process your request'
                    serverMsg={'Could not get error from cookie or unknown. cookie: ' + ckName + ' value: ' + ckValue}
                    errorCode={0}
                    auth={window.auth}
                    logPrefix='ErrorWrapperPage:' />
            );
        }
    }

    return (
        <div>
            {
                renderError()
            }
        </div>
    );
}

ErrorWrapperPage.displayName = 'ErrorWrapperPage';
export default ErrorWrapperPage;
